
import React from 'react';

const TypingIndicator = () => {
  return (
    <div className="flex space-x-1.5 px-4 py-2 bg-muted text-muted-foreground rounded-lg max-w-[80%]">
      <div className="w-2.5 h-2.5 rounded-full bg-current animate-pulse" style={{ animationDelay: "0ms" }} />
      <div className="w-2.5 h-2.5 rounded-full bg-current animate-pulse" style={{ animationDelay: "300ms" }} />
      <div className="w-2.5 h-2.5 rounded-full bg-current animate-pulse" style={{ animationDelay: "600ms" }} />
    </div>
  );
};

export default TypingIndicator;
